import { render, staticRenderFns } from "./salesMapping.vue?vue&type=template&id=6464e5ba&"
import script from "./salesMapping.vue?vue&type=script&lang=js&"
export * from "./salesMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports